// This must be the first line in src/index.tsx
// tslint:disable-next-line: no-implicit-dependencies
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import { Providers } from "./Providers";

ReactDOM.render(<Providers />, document.getElementById("root"));
